module.exports = require('./get');



//////////////////
// WEBPACK FOOTER
// ../node_modules/lodash/fp/property.js
// module id = 813
// module chunks = 32